import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: 'AIzaSyBxzVLuhfZiTbhHfNxs3RWY7gh_L_UfkeM',
    authDomain: 'advicas-29fad.firebaseapp.com',
    projectId: 'advicas-29fad',
    storageBucket: 'advicas-29fad.appspot.com',
    messagingSenderId: '449915822661',
    appId: '1:449915822661:web:9d824d5cf643f77141792c',
    measurementId: 'G-C3ZGR2YTF8'
};
const firebaseApp = initializeApp(firebaseConfig);
export const firebaseDB = getFirestore(firebaseApp);
export const auth = getAuth(firebaseApp);
